import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-8" }
const _hoisted_4 = { class: "col-xxl-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-8 col-md-7" }
const _hoisted_7 = { class: "col-lg-4 col-md-5" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-xxl-4 col-md-6" }
const _hoisted_10 = { class: "col-xxl-4 col-md-6" }
const _hoisted_11 = { class: "col-xxl-4 col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchoolOverview = _resolveComponent("SchoolOverview")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_UpcomingEvents = _resolveComponent("UpcomingEvents")!
  const _component_AttendanceAnalyticsChart = _resolveComponent("AttendanceAnalyticsChart")!
  const _component_Teachers = _resolveComponent("Teachers")!
  const _component_StudentsOverviewChart = _resolveComponent("StudentsOverviewChart")!
  const _component_NewAdmissionsChart = _resolveComponent("NewAdmissionsChart")!
  const _component_NoticeBoard = _resolveComponent("NoticeBoard")!
  const _component_StudentsList = _resolveComponent("StudentsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SchoolOverview),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Stats)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_UpcomingEvents)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AttendanceAnalyticsChart)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Teachers)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_StudentsOverviewChart)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_NewAdmissionsChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_NoticeBoard)
      ])
    ]),
    _createVNode(_component_StudentsList)
  ]))
}